import { createSlice } from '@reduxjs/toolkit';
import { DepartmentsState } from '../../types/department';

const initialState: DepartmentsState = {
  departments: [],
  selectedOutletId: null,
  isLoading: false,
  error: null,
};

const departmentsSlice = createSlice({
  name: 'departments',
  initialState,
  reducers: {},
});

export default departmentsSlice.reducer;
